import React from 'react';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { AppImage, brandclub_colors, useStacklineTheme } from '@stackline/ui';
import { SxProps } from '@mui/material/styles';

export const SearchTextField = ({
  startAdornment,
  sx,
  ...restProps
}: TextFieldProps & { startAdornment?: React.ReactNode; sx?: SxProps<Theme> }) => {
  const theme = useStacklineTheme();

  return (
    <TextField
      variant="standard"
      InputProps={{
        disableUnderline: true,
        startAdornment: startAdornment || (
          <AppImage
            src="/svg/icons/search.svg"
            alt="search-icon"
            style={{
              marginRight: 10,
              height: 16,
              width: 16
            }}
          />
        ),
        autoComplete: 'off',
        id: 'type-search'
      }}
      sx={{
        borderRadius: 17,
        border: `1px solid ${theme.colors.primaryGray}`,
        // padding: '8px 0px',
        width: 'fit-content',
        backgroundColor: brandclub_colors.white,
        '& div.MuiInput-root': {
          display: 'flex',
          alignItems: 'center',
          height: '20px',
          boxSizing: 'content-box',
          width: '262px',
          '& input': {
            padding: 0,
            fontSize: '14px',
            color: theme.colors.primary
          }
        },
        '.MuiInput-input::placeholder': {
          color: theme.colors.secondary,
          fontSize: '14px'
        },
        ...sx
      }}
      {...restProps}
    />
  );
};
